import InfoOutlined from "@mui/icons-material/InfoOutlined";
import { FormControlLabel, IconButton, Stack, Switch, Tooltip } from "@mui/material";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";

import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";

export type ScoutWriteAccessToggleProps = {
  value: boolean;
  disabled: boolean;
  onChange: (next: boolean) => void;
};

export function ScoutWriteAccessToggle({ value, disabled, onChange }: ScoutWriteAccessToggleProps) {
  const { featureFlags } = useFeatureFlags();
  if (!featureFlags?.[FeatureFlagKey.ScoutWriteAccess]) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2, py: 0.5 }}>
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={value}
            disabled={disabled}
            onChange={(event) => onChange(event.target.checked)}
            slotProps={{
              input: { role: "switch" },
            }}
            color="success"
          />
        }
        label="Allow Scout to change your data"
      />
      <Tooltip title="When on, Scout can make changes to your Encamp data using your own permissions. Turn off if you only want Scout to read.">
        <IconButton size="small" aria-label="More info about the Scout write-access toggle">
          <InfoOutlined fontSize="small" color="action" />
        </IconButton>
      </Tooltip>
    </Stack>
  );
}
